import React from "react";
import { useCountdown } from "@qgiv/core-donor";
import { getSingularPluralWordForm } from "@qgiv/core-js";
import { Icon } from "@qgiv/core-react";

/**
 * @param {object} props
 * @param {string} props.endDate
 * @returns {React.ReactElement}
 */
const MatchingCampaignsCountdown = ({ endDate }) => {
    const {
        days = 0,
        hours = 0,
        minutes = 0,
        seconds = 0,
    } = useCountdown({
        targetDate: endDate,
        shouldDisplaySecondsWhenDaysAreLeft: false,
    });

    return (
        <div className="qg-vendor-countdown countdown">
            <div className="countdown__icon">
                <Icon
                    glyph="clock-solid"
                    type="FontAwesome"
                    className="-type--large "
                />
            </div>
            {days > 0 && (
                <div className="countdown__item">
                    <div className="countdown__item--number">
                        <strong>{days}</strong>
                    </div>
                    <div className="countdown__item--title">
                        {getSingularPluralWordForm("day(s)", days)}
                    </div>
                </div>
            )}

            <div className="countdown__item">
                <div className="countdown__item---number">
                    <strong>{hours}</strong>
                </div>
                <div className="countdown__item--title">
                    {getSingularPluralWordForm("hour(s)", hours)}
                </div>
            </div>
            <div className="countdown__item">
                <div className="countdown__item--number">
                    <strong>{minutes}</strong>
                </div>
                <div className="countdown__item--title">
                    {getSingularPluralWordForm("min(s)", minutes)}
                </div>
            </div>

            {days <= 0 && (
                <div className="countdown__item">
                    <div className="countdown__item--number">
                        <strong>{seconds}</strong>
                    </div>
                    <div className="countdown__item--title">
                        {getSingularPluralWordForm("sec(s)", seconds)}
                    </div>
                </div>
            )}
        </div>
    );
};

export default MatchingCampaignsCountdown;
